import React from 'react';
import { observer } from "mobx-react";
import { Collapse, Descriptions,  Pagination, Row, Col } from 'antd';
import { RightOutlined, LeftOutlined, DownOutlined } from '@ant-design/icons';
import {translateText, getDirection} from "../../stores/objects/I18n"

const { Panel } = Collapse;

const LocResultsView = observer(class LocResultsView extends React.Component {
    
    renderResult(r, i) {
        let getTextItem = (result, field, fieldName) => (field in result ?
        (<Descriptions.Item label={translateText(this.props.store, fieldName)}>{r[field]}</Descriptions.Item>) :
        '');
        let getJoinedListItem = (result, field, fieldName) => (field in result ?
        (<Descriptions.Item label={translateText(this.props.store, fieldName)}>{r[field].join()}</Descriptions.Item>) :
        '');
        let header =  r['title'] + " / "
                     + (r['contributor'] !== undefined ? r['contributor'] : "Unknown") 
                     + (r['original_format'] !== undefined ? " (" + r['original_format'] + ")" : "")
                     + ". "
        const customPanelStyle = {
                        border: 0,
                        direction: getDirection(this.props.store)
                      };
        let urlSections = r['url'].split("/");
        let key = urlSections[urlSections.length -1];
        return (
            <Row type="flex" style={{direction:getDirection(this.props.store)}}>
                <Col span={20}>
                <Collapse bordered={false}
                    expandIconPosition={getDirection(this.props.store) === 'rtl' ? "right" : "left"}
                    expandIcon={({ isActive }) => 
                    (!isActive ? getDirection(this.props.store) === 'rtl' ? <LeftOutlined /> : <RightOutlined /> : <DownOutlined />)}>
                    
                
                        <Panel key={key} 
                            header={header} 
                            bordered={false} 
                            style={customPanelStyle}
                            id={key}>
                            <Descriptions bordered={false}>
                                {getTextItem(r, 'title', "Title")}
                                {getTextItem(r, 'contributor', "Contributor")}
                                {getJoinedListItem(r, 'language', "Language")}
                                {getTextItem(r, 'date', 'Date')}
                                {getJoinedListItem(r, 'description', "Description")}
                            </Descriptions>
                        </Panel>
                    </Collapse>
                </Col>
                <Col span={4}>
                    <div className="ant-collapse ant-collapse-borderless ant-collapse-icon-position-right">
                        <div className="ant-collapse-item" style={{border: "0px", direction: getDirection(this.props.store)}}>
                            <div class="ant-collapse-header" tabindex="0" aria-expanded="false">
                                <a href={r['url']} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    aria-labelledby={key}>
                                    {translateText(this.props.store, "Access item")}
                                </a>
                            </div>             
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }

    render(){
        let resView = this.props.searcher.results.map((r, i) => this.renderResult(r, i)); 
        return(
            <div>
            
               {resView}
           <Pagination defaultCurrent={this.props.searcher.paginationCurr} 
                       total={this.props.searcher.numResults}
                       pageSize={this.props.searcher.paginationPerpage} 
                       onChange={(page, pageSize) => this.props.searcher.movePage(page)}/>
           </div>
        )
    }
})


export default LocResultsView;

